module.exports = __webpack_public_path__ + "img/navegacao-ultimo.67c1d7a0.svg";